export * from "ce/reducers/moduleEntityReducers";
import { moduleEntityReducerObject as CE_moduleEntityReducerObject } from "ce/reducers/moduleEntityReducers";
import { combineReducers } from "redux";

const moduleEntityReducer = combineReducers({ ...CE_moduleEntityReducerObject });

export default moduleEntityReducer;
